import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import styled, { useTheme } from "styled-components";
import Text from "../Text";
import { useMobile } from "../../utils/mobile";

const StyledBox = styled.div(({ isMobile }) => ({
  marginTop: 25,
  flexWrap: isMobile ? "wrap" : "nowrap",
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  width: "100%",
  gap: 4,
  flexShrink: 0,
}));

const BoxContent = styled.div(({ width }) => ({
  width: width,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  background: "#EFF3F7",
  borderRadius: 7,
  textIndent: 14,
  height: 40,
  
  [`:last-of-type`]: {
    marginInlineEnd: 10,
  },
}));

const TableHeader = ({ keys, translation }) => {
  const { t, i18n } = useTranslation(translation);
  const theme = useTheme();
  const isMobile = useMobile();

  return (
    <>
      <StyledBox isMobile={isMobile}>
        <>
          {keys.map((key, index) => {
            return (
              <BoxContent
                width={key.width}
                key={`${key}${index}`}
                isRtl={i18n.dir() === "rtl"}>
                <Text.SR
                  style={{ color: theme.color.gray70, textAlign: "start" }}>
                  {t(key.key)}
                </Text.SR>
              </BoxContent>
            );
          })}
        </>
      </StyledBox>
    </>
  );
};

export default inject()(observer(TableHeader));
